<template>
  <b-modal id="passport" ref="modal" size="lg" :title="title" @show="setModal" @hidden="resetModal" ok-title="Save"
           @ok="handleOk">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Passport Type</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.passport_type" :state="isEmpty(input_data.passport_type)" v-model="input_data.passport_type" :reduce="passport_type=>passport_type.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Country </label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.country"  v-model="input_data.country" :reduce="country=>country.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Registered Name</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.registered_name)" v-model="input_data.registered_name" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Number</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="number" class="form-control" :state="isEmpty(input_data.registered_number)" v-model="input_data.registered_number" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Nationality </label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.nationality"  v-model="input_data.nationality" :reduce="nationality=>nationality.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Birth Place</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.birth_place)" v-model="input_data.birth_place" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Birth Date</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.birth_date"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Issue Office</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.issue_office)" v-model="input_data.issue_office" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Issuing Date</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.issue_date"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.expiry_date"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  <b-form-textarea
                      id="description"
                      placeholder="Description"
                      rows="4"
                      v-model="input_data.description"
                  ></b-form-textarea>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.status"
                      :options="options.status"
                      plain
                      name="plain-inline-status"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Default</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.default"
                      :options="options.default"
                      plain
                      name="plain-inline-default"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Is Locked</label>
                <div class="col-md-8 mb-3">
                  <b-form-checkbox
                      id="checkbox-1"
                      v-model="input_data.is_locked"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                  >
                    Yes, Locked
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {BForm, BFormGroup, BFormInput, BButton, BModal, BFormTextarea, BFormRadioGroup, BFormCheckbox} from "bootstrap-vue"

import flatPickr from 'vue-flatpickr-component'
import vSelect  from "vue-select"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
export default {
  name: "PassportInput",
  components:{
    BForm,
    BFormGroup,
    BFormInput,
    flatPickr,
    BButton,
    BModal,
    BFormTextarea,
    BFormRadioGroup,
    BFormCheckbox,
    vSelect
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      title:"Add",
      input_data:{
        passport_type:"",
        country:"",
        registered_name:"",
        registered_number:"",
        nationality: "",
        birth_place:"",
        birth_date:"",
        issue_office:"",
        issue_date:"",
        expiry_date:"",
        description:"",
        status:"active",
        default:false,
        is_locked:"accepted"
      },
      options:{
        passport_type:[],
        country:[],
        nationality: [],
        status:[{text:"Active", value:"active"}, { text:"Non Active", value:"non_active"}],
        default:[{text:"Yes", value:true}, { text:"No", value:"false"}],
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  methods:{
    isEmpty(val){
      return val !== ""
    },
    onSubmit(){
      let payload = {
        emp_id: this.$store.getters.empId,
        passtype_id:this.input_data.passport_type,
        country_id:this.input_data.country,
        registered_number:this.input_data.registered_number,
        registered_name:this.input_data.registered_name,
        nationality_country_id:this.input_data.nationality,
        birth_place:this.input_data.birth_place,
        birth_date:this.input_data.birth_date,
        issue_date:this.input_data.issue_date,
        issue_office:this.input_data.issue_office,
        expiry_date:this.input_data.expiry_date,
        status:(this.input_data.status === "active" ? 1:0),
        desc:this.input_data.description,
        user_id:this.$store.getters.userId
      }

      if (this.data !== null ){
        payload.id=this.data.id
        AxiosCall.Put(payload, urlApi.passport.update).then(res=>{
          if(res.success){
            this.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.Post(payload, urlApi.passport.add).then(res=>{
          if(res.success){
            this.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }
    },
    handleOk(bvModalEvt){
      bvModalEvt.preventDefault()
      this.onSubmit()
    },
    resetModal(){
      this.$parent.data = null
      this.title = "Add"
      this.input_data = {
        passport_type:"",
        country:"",
        registered_name:"",
        registered_number:"",
        nationality: "",
        birth_place:"",
        birth_date:"",
        issue_office:"",
        issue_date:"",
        expiry_date:"",
        description:"",
        status:"active",
        default:false,
        is_locked:"accepted"
      }
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    getPassportType(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.passport.type).then(res=>{
        if(res.success){
          this.options.passport_type = res.atributes
        }else {
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    getCountry(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.country.list).then(res=>{
        if(res.success){
          this.options.country = res.atributes
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    getNationality(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.country.nationality.list).then(res=>{
        if(res.success){
          this.options.nationality = res.atributes
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    setModal(){
      setTimeout(()=>{
        if (this.data !== null){
          this.title = "Update"
          this.input_data.passport_type = this.data.type_id
          this.input_data.registered_name = this.data.passport_name
          this.input_data.registered_number = this.data.passport_number
          this.input_data.country = this.data.country_id
          this.input_data.nationality = this.data.nationality_id
          this.input_data.birth_place = this.data.place_of_birth
          this.input_data.birth_date = this.data.date_of_birth
          this.input_data.issue_office = this.data.issuing_office
          this.input_data.issue_date = this.data.date_of_issue
          this.input_data.expiry_date = this.data.date_of_expired
          this.input_data.description = this.data.desc
          this.input_data.status = (this.data.status === 1?'active':'non_active')
          this.input_data.default = (this.data.is_default === "1" ? true:false)
          this.input_data.is_locked = (this.data.is_locked === 1 ? 'accepted':'')
        }
      }, 100)
    }
  },
  created() {
    this.getPassportType()
    this.getCountry()
    this.getNationality()
  }
}
</script>